export const mutations = {
    setTroca(state, data) {
        state.troca = data
    },
    setTrocaVenda(state, data) {
        state.trocaVenda = data
    },
    setProdutosTrocaVenda(state, data) {
        state.produtosTrocaVenda = data
    },
    addProdutoTrocaVenda(state, data) {
        state.produtosTrocaVenda.push(data)
    },
    removeProdutoTrocaVenda(state, data) {
        const index = state.produtosTrocaVenda.map(x => x.id).indexOf(data.id);
        state.produtosTrocaVenda.splice(index, 1)
    },
    setProdutosTroca(state, data){
        state.produtosTroca = data
    },
    addProdutoTroca(state, data) {
        state.produtosTroca.push(data)
    },
    removeProdutoTroca(state, data) {
        const index = state.produtosTrocaVenda.map(x => x.id).indexOf(data.id);
        state.produtosTroca.splice(index, 1)
    },
    setModalTrocaVenda(state, status) {
        state.modalTrocaVenda = status
    },
}

export default {}